import axios from "axios";
import Cookies from "js-cookie";
import { HOST_NAME } from "../utils/constants";

export const createScreen = async (
  data: any,
  thumbnails: File[],
) => {
  return new Promise((resolve, reject) => {
    // Configure the request
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    // Send the request
    axios
      .request(config)
      .then(async (response) => {
        await uploadThumbnailToS3(
          response?.data?.data?._id,
          thumbnails[0],
        );
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateScreen = async (
  id: string,
  data: any,
  thumbnailFiles?: File[]
) => {

  return new Promise((resolve, reject) => {
    const config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen/${id}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then(async (response) => {
        if (thumbnailFiles && thumbnailFiles?.length > 0) {
          await uploadThumbnailToS3(
            response?.data?.data?._id,
            thumbnailFiles[0],
          );
        }
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const uploadThumbnailToS3 = async (
  screenId: string,
  thumbnail: File,
) => {
  let thumbnailUrl: string = "";

  //Upload Thumbnail and get the url
  if (thumbnail) {
    await uploadFileToS3(thumbnail, { screenId }, "screen")
      .then((res: any) => (thumbnailUrl = res.signedUrl.split("?")[0]))
      .catch((err) => console.log("error uploading thumbnail"));

    //Update the screen i.e add the thumbnailUrl
    await updateScreen(screenId, { thumbnailUrl })
      .then((res) => {
        console.log("ThumbnailUrl added successfully.");
      })
      .catch((err) => "error adding thumbnailUrl.");
  }
};

export const uploadFileToS3 = (
  file: File,
  metadata: any,
  folderName: string
) => {
  return new Promise((resolve, reject) => {
    // Step 1: Get pre-signed URL
    const configPresignedUrl = {
      method: "post",
      url: `${HOST_NAME}/generate-presigned-url`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
        "Content-Type": "application/json",
      },
      data: {
        fileName: file.name,
        fileType: file.type,
        metadata,
        folderName,
      },
    };

    axios
      .request(configPresignedUrl)
      .then(async (response) => {
        const { signedUrl, key } = response?.data?.data;

        // Step 2: Upload file to S3
        const configUploadToS3 = {
          method: "put",
          url: signedUrl,
          headers: {
            "Content-Type": file.type,
          },
          data: file,
        };

        const res = await axios
          .request(configUploadToS3)
          .then(() => ({ signedUrl, key }));

        return res;
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        reject(error);
      });
  });
};

export const uploadDocument = async (file: any) => {
  let formData = new FormData();
  formData.append("files", file);
  try {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/documents/upload`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    };

    const response = await axios.request(config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getAllScreens = (filters?: any) => {
  let status: string = "";
  if (filters?.status) {
    status = filters?.status;
  }

  return new Promise((resolve, reject) => {
    const categoriesArray = filters?.categories || [];
    const collectionsArray = filters?.collections || [];
    const licensesArray = filters?.licenses || [];

    const categoriesJSON =
      categoriesArray?.length !== 0
        ? `${categoriesArray?.map((element: any) => `"${element}"`).join(" ")}`
        : "";

    const collectionsJSON =
      collectionsArray?.length !== 0
        ? `${collectionsArray?.map((element: any) => `"${element}"`).join(" ")}`
        : "";

    const licensesJSON =
      licensesArray?.length !== 0
        ? `${licensesArray?.map((element: any) => `"${element}"`).join(" ")}`
        : "";

    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen?search=${filters?.searchBy || ""}&searchByTitle=${
        filters?.searchByTitle || ""
      }&page=${filters?.page || 1}&pageSize=${
        filters?.pageSize || 25
      }&category=${categoriesJSON}&collection=${collectionsJSON}&license=${licensesJSON}&status=${status}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getScreenById = (id: string) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen/${id}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getScreenSourceCodeByScreenId = (screenId: string) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen-source/${screenId}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteScreen = (id: string) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/screen/${id}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteDocumentsByUrl = (data: any) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/documents/url`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: { urls: data },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteDocuments = (data: any) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/documents`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: { documentIds: data },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateMultipleScreens = (data: any) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/multiple-screen`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAllScreensFeedback = (filters?: any) => {
  return new Promise<any>((resolve, reject) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/feedbacked-screen?search=${
        filters?.searchBy || ""
      }&page=${filters?.page || 1}&pageSize=${filters?.pageSize || 25}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

// export const getAllParticularScreenFeedbacks = (filters?: any) => {
//   return new Promise((resolve, reject) => {
//     const page =
//       filters?.page !== undefined &&
//       filters?.page !== null &&
//       filters?.page !== ""
//         ? filters?.page
//         : "";
//     const pageSize =
//       filters?.pageSize !== undefined &&
//       filters?.pageSize !== null &&
//       filters?.pageSize !== ""
//         ? filters?.pageSize
//         : "";
//     const screenId =
//       filters?.screenId !== undefined &&
//       filters?.screenId !== null &&
//       filters?.screenId !== ""
//         ? filters?.screenId
//         : "";

//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/feedback?screenId=${screenId}&page=${page}&pageSize=${pageSize}`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response.data.data);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

export const updateFeedbackById = (data: any, id: string) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/feedback/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const getAllScreensReport = (filters?: any) => {
  return new Promise<any>((resolve, reject) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/reported-screen?search=${
        filters?.searchBy || ""
      }&page=${filters?.page || 1}&pageSize=${filters?.pageSize || 25}`,
      headers: {
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

// export const getAllReports = (filters?: any) => {
//   return new Promise((resolve, reject) => {
//     const page =
//       filters?.page !== undefined &&
//       filters?.page !== null &&
//       filters?.page !== ""
//         ? filters?.page
//         : "";
//     const pageSize =
//       filters?.pageSize !== undefined &&
//       filters?.pageSize !== null &&
//       filters?.pageSize !== ""
//         ? filters?.pageSize
//         : "";
//     const screenId =
//       filters?.screenId !== undefined &&
//       filters?.screenId !== null &&
//       filters?.screenId !== ""
//         ? filters?.screenId
//         : "";

//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/problem?screenId=${screenId}&page=${page}&pageSize=${pageSize}`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response?.data?.data);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

export const updateReportById = (data: any, id: string) => {
  return new Promise((resolve, reject) => {
    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${HOST_NAME}/problem/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("jstoken")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

// export const getAllScreensCollections = (filters?: any) => {
//   return new Promise<any>((resolve, reject) => {
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/collection?search=${filters?.searchBy || ""}&page=${
//         filters?.page || 1
//       }&pageSize=${filters?.pageSize || 25}&includeScreens=${
//         filters?.includeScreens || ""
//       }&type=${filters?.type || ""}`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//         "Content-Type": "application/json",
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response?.data?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//         reject(error);
//       });
//   });
// };

// export const createScreenCollection = (data: any) => {
//   return new Promise<any>((resolve, reject) => {
//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/collection`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response?.data?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//         reject(error);
//       });
//   });
// };

// export const deleteScreenCollection = (id: string) => {
//   return new Promise<void>((resolve, reject) => {
//     let config = {
//       method: "delete",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/collection/${id}`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response?.data?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//         reject(error);
//       });
//   });
// };

// export const updateScreenCollection = (id: any, data: any) => {
//   return new Promise<any>((resolve, reject) => {
//     let config = {
//       method: "patch",
//       maxBodyLength: Infinity,
//       url: `${HOST_NAME}/collection/${id}`,
//       headers: {
//         Authorization: `Bearer ${Cookies.get("jstoken")}`,
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         resolve(response?.data?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//         reject(error);
//       });
//   });
// };
